import { RefProfileReportInfo } from './Job/JobReportInfo.model';

export class CompanyCounts {
    totalEmployees: number;
    totalTagged: number;
    totalAssessed: number;
    matchedReferenceProfilesInfo: {
        employeeCount: number;
        refProfileInfo: RefProfileReportInfo;
    }[];
}
